import type { ButtonOwnProps } from '@mui/material/Button';
import MuiButton from '@mui/material/Button';
import { colors } from '@src/common/styles/valueTokens';
import type { ReactNode } from 'react';
import type { To } from 'react-router-dom';
import { Link } from 'react-router-dom';

type Props = {
  to: To;
  children: ReactNode;
  variant?: 'contained' | 'text';
  external?: boolean;
} & ButtonOwnProps;

export const ButtonLink = ({
  to,
  children,
  variant = 'contained',
  external = false,
  ...rest
}: Props) => {
  return (
    <MuiButton
      sx={
        variant === 'contained'
          ? { backgroundColor: colors.primary['40'], borderRadius: '99px' }
          : undefined
      }
      component={Link}
      to={to}
      target={external ? '_blank' : undefined}
      variant={variant}
      {...rest}
    >
      {children}
    </MuiButton>
  );
};
